import React from "react";
import Header from "../../../Header/Header";
import Faq from "./Faq";
import TextSection1 from "./TextSection1";
import FooterSection from "../FooterSection";
import HeroSection from "./HeroSection";
import GenerationSteps from "./GenerationSteps";
import CompanySection from "./CompanySection";

const WhatsAppButton = () => {
  return (
    <>
      <Header />
      <HeroSection />
      <CompanySection />
      <GenerationSteps/>
      <Faq />
      <TextSection1 />
      <FooterSection />
    </>
  );
};

export default WhatsAppButton;
